import type { Area } from "react-easy-crop"

import type { Lecture } from "@/types/lectureTypes"
import type { StudentProfile } from "@/types/profileTypes"
import type { Round } from "@/types/roundTypes"
import moment from "moment"

export const isRTL = (text?: string) => {
  const arabicRegex =
    /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/

  return arabicRegex.test(text || "")
}

export const getDir = (text?: string) => (isRTL(text) ? "rtl" : "ltr")

export function checkProfileComplete(userProfile?: StudentProfile) {
  const requiredFields = [
    "name",
    "email",
    "phone",
    "birthdate",
    "country",
    "gov",
    "college",
    "profession_id",
    "student_status",
  ] as const
  // check if missing army status and is a male;

  if (
    userProfile?.gender != undefined &&
    userProfile?.gender === 0 &&
    !userProfile?.army_status
  ) {
    console.warn("missing army status")
    return false
  }

  return requiredFields.every((field) => {
    const value = userProfile?.[field]
    const result = value !== null && value !== undefined && value !== ""

    if (!result) {
      console.warn(`Missing required field: ${field}`)
    }
    return result
  })
}

export function getCroppedImg(imageSrc: string, crop: Area) {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.src = imageSrc
    image.onload = () => {
      const canvas = document.createElement("canvas")
      const ctx = canvas.getContext("2d") as CanvasRenderingContext2D

      canvas.width = crop.width
      canvas.height = crop.height

      ctx.drawImage(
        image,
        crop.x,
        crop.y,
        crop.width,
        crop.height,
        0,
        0,
        crop.width,
        crop.height
      )

      canvas.toBlob((blob) => {
        if (!blob) return reject(new Error("Failed to crop image"))
        resolve(new File([blob], "cropped.jpeg", { type: "image/jpeg" }))
      }, "image/jpeg")
    }
    image.onerror = (e) => reject(e)
  })
}

export function filterData<T extends Record<string, unknown>>(data: T) {
  const newData = { ...data }
  for (const key in data) {
    if (!newData[key]) {
      delete newData[key]
    }
  }
  return newData
}

export const getEmbedUrl = (url?: string) => {
  if (!url) return null

  try {
    const parsed = new URL(url)

    if (
      parsed.hostname.includes("youtube.com") ||
      parsed.hostname.includes("youtu.be")
    ) {
      const videoId =
        parsed.hostname === "youtu.be"
          ? parsed.pathname.slice(1)
          : parsed.searchParams.get("v")
      return {
        type: "youtube",
        url: `https://www.youtube.com/embed/${videoId}`,
      }
    }

    if (parsed.hostname.includes("drive.google.com")) {
      const match = url.match(/\/d\/([a-zA-Z0-9_-]+)/)
      const videoId = match?.[1]
      return {
        type: "drive",
        url: `https://drive.google.com/file/d/${videoId}/preview`,
      }
    }

    return {
      type: "direct",
      url,
    }
  } catch {
    return null
  }
}

export function allowAttendOnlineLecture(lecture?: Lecture, round?: Round) {
  const attended = lecture?.my_evaluation?.is_attend

  const todaysLecture =
    lecture?.start_time && moment(lecture.start_time).isSame(new Date(), "day")

  const allowAttendLecture =
    todaysLecture && !attended && Number(round?.type) === 1

  return allowAttendLecture
}

export function getFirstWords(text: string, n: number = 2) {
  return text?.split(" ")?.slice(0, n)?.join(" ")
}
